<template>
  <div style="padding: 0 20px; background: #fff">
    <a-tabs :activeKey="activeKey" destroyInactiveTabPane @change="changeTab">
      <a-tab-pane v-for="(item, index) in tabList" :key="item.key" :tab="item.tab">
        <SchemeCard
          ref="schemeCardRef"
          :activeKey="item.key"
          :actionUrl="item.url"
          :keysFormArr="item?.keysFormArr"
        />
      </a-tab-pane>
      <a-button type="primary" slot="tabBarExtraContent" @click="createLeague">创建</a-button>
    </a-tabs>
  </div>
</template>
<script>
import SchemeCard from '@/comUi/SchemeCard/components/SchemeCard.vue'

const keysFormArr = [
  'title',
  'cover',
  // 'courseDesc',
  'file',
  'content',
]

export default {
  name: 'TeacherPsyCare',
  components: {
    SchemeCard,
  },
  data() {
    return {
      activeKey: '17',
      // tabList: [
      //   {
      //     tab: '辅导方案',
      //     key: '8',
      //     url: 'resourceCource',
      //     cateDictCode: 'course_sort',
      //     keysFormArr: [...keysFormArr, 'classify'],
      //   },
      //   {
      //     tab: '主题方案',
      //     key: '9',
      //     url: 'resourceCource',
      //     gradeDictCode: 'course_applicable_grade',
      //     cateDictCode: 'course_sort',
      //     keysFormArr: [...keysFormArr, 'classify', 'applicableGrade'],
      //   },
      //   {
      //     tab: '文化建设',
      //     key: '10',
      //     url: 'resourceCource',
      //     keysFormArr: [...keysFormArr],
      //   },
      //   {
      //     tab: '专题活动',
      //     key: '11',
      //     url: 'resourceCource',
      //     keysFormArr: [...keysFormArr],
      //   },
      // ],
      tabList: [
        {
          tab: '教师心理测评',
          key: '17',
          url: 'resourceCource',
          keysFormArr: [...keysFormArr],
        },
        {
          tab: '线上树洞',
          key: '18',
          url: 'resourceCource',
          keysFormArr: [...keysFormArr],
        },
        {
          tab: '教师幸福感提升解决方案',
          key: '19',
          url: 'resourceCource',
          keysFormArr: [...keysFormArr],
        },
      ],
    }
  },
  created() {
    const backKey = this.$router.history.current.query.activeKey
    if (backKey) {
      this.activeKey = backKey
    }
  },
  methods: {
    changeTab(key) {
      this.activeKey = key
    },
    createLeague() {
      this.$refs.schemeCardRef[0].showCardModal()
    },
  },
}
</script>
